<template>
  <ModalTemplate :showModal="isModalActive" :width="widthModal" @closeModal="closeModal">
    <template v-slot:headerModal>
      <div class="is-flex is-justify-content-space-between is-align-items-center">
        <p class="averta-bold label-18">Notifikasi {{ dataNotifikasi?.label }}</p>
        <div class="is-clickable" @click="closeModal">
          <b-icon icon="close"></b-icon>
        </div>
      </div>
    </template>
    <template v-slot:bodyModal>
      <div class="wrap-body-modal p-5">
        <!-- Filter -->
        <div class="wrap-title-and-filter">
          <div class="is-flex is-justify-content-space-between is-align-items-center">
            <div class="mb-4">
              <p class="averta-bold label-16">Daftar {{ dataNotifikasi?.label }}</p>
              <p class="text-grey label-14">{{ dataNotifikasi?.count }} Project</p>
            </div>
            <div v-if="dataNotifikasi?.label !== 'Menunggu Opsi Pembayaran'">
              <p class="averta-bold label-16">Filter Menungggu Pembayaran</p>
            </div>
          </div>
          <div class="filter is-flex is-justify-content-space-between is-align-items-center">
            <div class="is-flex">
              <b-dropdown aria-role="list" v-model="searchBy">
                <template #trigger="{ active }">
                  <b-button :icon-right="active ? 'menu-up' : 'menu-down'">
                    <div class="is-flex is-align-items-center pr-6 search-by-wrapper">
                      <p>{{ searchBy ? searchBy === 'customer_name' ? 'Customer Name' : 'ID Survey' :
                        'Pilih Filter' }}
                      </p>
                    </div>
                  </b-button>
                </template>
                <b-dropdown-item value="customer_name">Customer Name</b-dropdown-item>
                <b-dropdown-item value="survey_id">ID Survey</b-dropdown-item>
              </b-dropdown>
              <b-field class="c-w-sm-100">
                <b-input placeholder="Masukkan Keyword" type="search" icon="magnify" v-model="search"
                  @keyup.native.enter="getPaymentNotification">
                </b-input>
              </b-field>
              <b-button type="is-text" @click="handleReset">
                <b-icon icon="refresh"></b-icon>
              </b-button>
            </div>
            <div class="is-flex is-align-items-center search-by-wrapper" v-if="dataNotifikasi?.label !== 'Menunggu Opsi Pembayaran'">
              <div class="filter-button">
                <ButtonApp
                  type="is-ghost"
                  @click="handleNotificationClick({optionPayment: 'full'})"
                  :isSecondary="true"
                >
                  <span style="font-weight: bold;">
                    Menunggu Pembayaran Penuh
                  </span>
                </ButtonApp>
              </div>
              <div class="filter-button">
                <ButtonApp
                  type="is-ghost"
                  @click="handleNotificationClick({optionPayment: 'installment', phase: 1})"
                  :isSecondary="true"
                >
                  <span style="font-weight: bold;">
                    Menunggu Termin 1 (DP)
                  </span>
                </ButtonApp>
              </div>
              <div class="filter-button">
               <ButtonApp
                type="is-ghost"
                @click="handleNotificationClick({optionPayment: 'installment', phase: 2})"
                :isSecondary="true"
              >
                <span style="font-weight: bold;">
                 Menunggu Termin 2
                </span>
              </ButtonApp>
              </div>
              <div class="filter-button">
                <ButtonApp
                  type="is-ghost"
                  @click="handleNotificationClick({optionPayment: 'installment', phase: 3})"
                  :isSecondary="true"
                >
                  <span style="font-weight: bold;">
                    Menunggu Pelunasan
                  </span>
                </ButtonApp>
              </div>
            </div>
          </div>
        </div>
        <!-- Filter -->

        <div class="loading-wrapper" v-if="isLoading">
          <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false">
            <SpinnerIcon />
          </b-loading>
        </div>
        <!-- LIST -->
        <div v-if="!isLoading && data && data.length > 0">
          <div
            class="expired-card"
            v-for="(item, i) in data"
            :key="i"
          >
            <div class="is-flex is-justify-content-space-between is-align-items-center">

              <!-- LEFT SIDE (Grid 1) -->
              <div class="is-flex" style="flex: 1;">

                <!-- ID BOX -->
                <div class="id-box mr-4">
                  <p class="id-label">ID</p>
                  <p class="id-value">{{ item.survey_id }}</p>
                </div>

                <!-- NAME & PHONE -->
                <div class="customer-info mr-5">
                  <p class="customer-name averta-bold">{{ item.customer_name }}</p>
                  <div class="is-flex is-align-items-center">
                    <b-icon icon="phone-outline" size="is-small"></b-icon>
                    <p class="customer-phone ml-2">{{ item.customer_phone }}</p>
                  </div>
                </div>

                <!-- STATUS -->
                <div v-if="dataNotifikasi?.label !== 'Menunggu Opsi Pembayaran'" class="status-block mr-5">
                  <p class="status-label">STATUS</p>
                  <div class="is-flex is-align-items-center">
                    <span
                      class="status-dot"
                      :class="{
                        'is-green': item.payment_option === 'FULL',
                        'is-orange': item.payment_option === 'INSTALLMENT'
                      }"
                    ></span>
                    <p class="status-value ml-2">
                      {{ item.payment_option === 'INSTALLMENT'
                        ? item.installment_phase === 1 ? `Menunggu Pembayaran Termin ${item.installment_phase}(DP)` : item.installment_phase === 3 ? 'Menunggu Pelunasan': `Menunggu Pembayaran Termin ${item.installment_phase}`
                        : 'Menunggu Pembayaran Penuh'
                      }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- APPROVED DATE (Grid 2) -->
              <div class="approved-block" style="flex: 1; text-align: center;">
                <p class="approved-label">TANGGAL DISETUJUI</p>
                <div class="is-flex is-align-items-center is-justify-content-center">
                  <b-icon icon="calendar-month" size="is-small"></b-icon>
                  <p class="approved-value ml-2">{{ convertDate(item.approved_at) }}</p>
                </div>
              </div>

              <!-- RIGHT SIDE (Grid 3) -->
              <div class="is-flex is-justify-content-flex-end is-align-items-center" style="flex: 1;">
                <!-- TOTAL -->
                <div class="total-block mr-5" style="margin-left: auto; margin-right: 2rem; min-width: 200px; text-align: right;">
                  <p class="total-label">TOTAL</p>
                  <p class="total-value averta-bold">{{ formatThousand(item.installment_amount) }}</p>
                </div>
                <p class="lihat-detail text-merah is-clickable" @click="handleDetail(item.survey_id)">
                  Lihat Detail →
                </p>
              </div>

            </div>
          </div>
          <!-- Pagination -->
          <PaginationApp :total-pages="totalPages" :current-page="currentPage" :isNew="true" :load-page="getPaymentNotification" :limit-data="limitPage" :total-data="totalData" />
          <!-- Pagination -->
        </div>
        <!-- Data not Found -->
        <div v-else class="is-flex is-flex-direction-column is-justify-content-space-between is-align-items-center">
          <ProyekEmptyIcon />
          <p class="averta-bold">Tidak ada request reschedule</p>
        </div>
        <!-- Data not Found -->
      </div>
    </template>
  </ModalTemplate>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import ModalTemplate from './ModalTemplate.vue'
import PaginationApp from '@/components/PaginationApp.vue'
import { ProyekEmptyIcon, SpinnerIcon } from '@/components/icons'
import { handleCopyText, formatCurrencyReturnZero as formatCurrency } from '@/helpers'
import ButtonApp from '@/components/button/ButtonApp'

export default {
  name: 'ModalPaymentNotifications',
  components: { ModalTemplate, PaginationApp, ProyekEmptyIcon, SpinnerIcon, ButtonApp },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      user: 'auth/user'
    })
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '75vw'
    },
    isDashboard: {
      type: Boolean,
      default: false
    },
    dataNotifikasi: {
      type: Object,
      default: () => ({})
    },
    dataPayment: {
      type: Object,
      default: () => ({})
    },
    statusNotification: {
      type: String,
      default: ''
    }
  },
  data () {
    console.log('dataNotifikasi:', this.dataPayment) // Debug
    return {
      isLoading: false,
      isModalActive: false,
      widthModal: this.width,
      search: '',
      searchBy: '',
      vendor: null,
      data: this.dataPayment,
      currentPage: 1,
      totalPages: 0,
      totalData: 0,
      limitPage: 5,
      status: this.statusNotification
    }
  },
  methods: {
    closeModal () {
      this.$emit('closeModal')
      this.search = ''
      this.searchBy = ''
    },
    formatThousand (amount) {
      return formatCurrency(amount)
    },
    convertDate (date, format) {
      if (!date) {
        return '-'
      }
      let initFormat = 'DD MMMM YYYY'
      if (format) {
        initFormat = format
      }
      return moment(date).format(initFormat)
    },
    handleNotificationClick (props = {}) {
      const { pages = 1, optionPayment, phase } = props
      console.log(optionPayment, 'ini option payment')
      const payload = {
        url: this.url,
        search: this.search,
        search_by: this.searchBy,
        page: pages,
        limit: this.limitPage,
        status: this.status,
        optionPayment,
        phase
      }

      if (payload) {
        this.getPaymentNotification(payload)
      }
    },
    getPaymentNotification (props = {}) {
      const { pages = 1, dataVendor = null, optionPayment, phase } = props

      if (this.searchBy && !this.search) {
        return
      }

      console.log(this.search, this.searchBy, 'search and searchby')

      this.isLoading = true

      const payload = {
        url: this.url,
        search: this.search,
        search_by: this.searchBy,
        page: pages,
        limit: this.limitPage,
        status: this.status,
        optionPayment,
        phase
      }

      if (dataVendor) {
        payload.vendor = dataVendor.name
        this.vendor = dataVendor.name
      } else if (this.vendor !== null) {
        payload.vendor = this.vendor
      }
      this.$store
        .dispatch('notificationPayment/getNotificationList', payload)
        .then(response => {
          console.log(response.data.data.data, 'dataPayment')
          this.data = response.data.data.data
          this.currentPage = response.data.data.pagination.currentPage
          this.totalPages = response.data.data.pagination.totalPages
          this.totalData = response.data.data.pagination.totalItems
          this.$emit('totalReschedule', response.data.total_data)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          console.log(error)
        })
    },
    handleCopy (text) {
      handleCopyText(text)
    },
    handleDetail (id) {
      let role
      if (this.user.roles[0].name === 'Account Manager') {
        role = 'am'
      } else {
        role = 'sm'
      }

      this.$router.push({ path: `/${role}/project/survey/${id}/detail` })
    },
    handleReset () {
      this.search = null
      this.searchBy = null
      this.getPaymentNotification()
    }
  },
  created () {
    this.getPaymentNotification()
  },
  watch: {
    showModal (newValue) {
      this.isModalActive = newValue
      // if (newValue) {
      //   this.getPaymentNotification()
      // }
    },
    width (newValue) {
      this.widthModal = newValue
    },
    search (newValue) {
      if (newValue === '') {
        this.getPaymentNotification()
      }
    },
    dataPayment (newValue) {
      this.data = newValue.data
      this.currentPage = newValue.pagination.currentPage
      this.totalPages = newValue.pagination.totalPages
      this.totalData = newValue.pagination.totalItems
      this.limitPage = 5
    },
    statusNotification (newValue) {
      this.status = newValue
    }
  }
}
</script>

<style scoped>
.border-right {
  border-right: solid 1px #9A9A9A;
}

.wrap-title-and-filter {
  border-bottom: dashed 2px #E5E5E5;
  padding-bottom: 24px;
  margin-bottom: 24px;
}

.wrap-body-modal {
  height: 75vh;
  overflow-y: auto;
}

.wrap-list {
  min-height: 35vh;
}

.loading-wrapper {
  height: 60%;
  width: 100%;
  position: relative;
}
.filter-button {
  padding: 5px;
}
.expired-card {
  background: white;
  border-radius: 12px;
  border: 1px solid #eeeeee;
  padding: 16px 20px;
  margin-bottom: 14px;
}

.id-box {
  background: #fdecec;
  width: 60px;
  height: 55px;
  border-radius: 8px;
  text-align: center;
  padding: 6px;
}

.id-label {
  font-size: 10px;
  color: #a1a1a1;
  margin-bottom: 0;
}

.id-value {
  font-size: 18px;
  font-weight: bold;
  color: #aa0000;
  margin-top: -4px;
}

.customer-name {
  font-size: 14px;
}

.customer-phone {
  font-size: 12px;
  color: #777;
}

.status-label,
.approved-label,
.total-label {
  font-size: 11px;
  color: #999;
  text-transform: uppercase;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.is-green {
  background: #11c63f;
}

.is-orange {
  background: #ff9d00;
}

.total-value {
  color: #a30000;
  font-size: 16px;
}

.lihat-detail {
  font-weight: bold;
  font-size: 14px;
}

</style>
